export default __webpack_public_path__ + "static/media/icon-dinein.512469ce.svg";